import React, { useCallback } from "react";

import { BrandSoftwareTypeOption } from "@/features/ui/types";

import { Col, Container, Row } from "react-bootstrap";

import ControlPanelButton from "../components/ControlPanelButton/ControlPanelButton";

import BrandModal from "@/common/Modal/BrandModal";
import styles from "./GenericControlPanelModal.module.scss";

interface Props {
  leftPanelButtons: BrandSoftwareTypeOption[];
  onClickLeftPanelButton: (option: BrandSoftwareTypeOption) => void;
  onHide?: () => void;
  rightPanelComponent: React.ReactNode;
  selectedOption: BrandSoftwareTypeOption;
  show: boolean;
  destroyOnHidden?: boolean;
}

const GenericControlPanelModal: React.FC<Props> = ({
  leftPanelButtons,
  onClickLeftPanelButton,
  onHide,
  rightPanelComponent,
  selectedOption,
  show,
  destroyOnHidden,
}) => {
  const handleOnClickLeftPanelButton = useCallback(
    (option: BrandSoftwareTypeOption) => () => {
      onClickLeftPanelButton(option);
    },
    [onClickLeftPanelButton]
  );

  return (
    <BrandModal
      title="Remote Console"
      style={{ top: 110, left: 100 }}
      open={show}
      footer={null}
      width="60%"
      onCancel={onHide}
    >
      <Container fluid>
        <Row>
          <Col className={styles.leftPanel} sm={4}>
            {leftPanelButtons.map((option) => (
              <ControlPanelButton
                key={option.value}
                option={option}
                onClick={handleOnClickLeftPanelButton(option)}
                isSelected={selectedOption.value === option.value}
              />
            ))}
          </Col>
          <Col sm={8}>
            <div className={styles.rightPanelPadding}>
              {show || !destroyOnHidden ? rightPanelComponent : null}
            </div>
          </Col>
        </Row>
      </Container>
    </BrandModal>
  );
};

export default GenericControlPanelModal;
